module.exports = __webpack_public_path__ + "static/media/mini-capa.eac08901.png";